import { useRef, useEffect } from "react";

import { Toaster } from "components";

import { func_validation } from "functions";


export function useSubmission(props) {
    // Props
    const { 
        addPermission_status,
        removePermission_status,
        isRenderingRequired,
    } = props;

    let updatedData = useRef({ deleted: {}, added: {} });
    
    function handlePermissionUpdate() {
        // Note: Action is delete or added
        let updateData_added = [];
        let updateData_deleted = [];
        for (const action in updatedData.current) {
            if (updatedData.current.hasOwnProperty(action)) {
                const actionValue = updatedData.current[action];
                
                for (const userGroupId in actionValue) {
                    if (actionValue.hasOwnProperty(userGroupId)) {
                        const userGroupIdValue = actionValue[userGroupId];
                        
                        for (const permission in userGroupIdValue) {
                            if (userGroupIdValue.hasOwnProperty(permission)) {
                                const permissionValue = userGroupIdValue[permission];
                                
                                if (func_validation.isStringEqual_caseInsensitive(action, "added")) {
                                    let obj = {
                                        ID: 0,
                                        PermissionName: permission,
                                        UserGroupId: userGroupId
                                    }

                                    updateData_added.push(obj);
                                }
                                else {
                                    updateData_deleted.push(permissionValue);
                                }
                            }
                        }
                    }
                }
            }
        }

        if (func_validation.isArrayNotEmpty(updateData_added) &&
            props.addPermission) {
            
            if (true || func_validation.isUserAccessGranted(props, "Dealer_Permission_Add")) {
                props.addPermission(updateData_added);
            }
            else {
                Toaster({ 
                    type: "error",
                    msg: "No permission granted to add permission"
                });
            }
        }

        if (func_validation.isArrayNotEmpty(updateData_deleted) &&
            props.removePermission) {
            
            if (true || func_validation.isUserAccessGranted(props, "Dealer_Permission_Delete")) {
                props.removePermission(updateData_deleted);
            }
            else {
                Toaster({ 
                    type: "error",
                    msg: "No permission granted to delete permission"
                });
            }
        }
    }
    useEffect(() =>{
        let updatedData_new = func_validation.deepCloneObject(updatedData.current);

        if (func_validation.isBooleanTrueNotNullUndefined(removePermission_status)) {
            updatedData_new.deleted = {};
        }

        if (func_validation.isBooleanTrueNotNullUndefined(addPermission_status)) {
            updatedData_new.added = {};
        }

        if (props.setIsRenderingRequired) {
            props.setIsRenderingRequired(!isRenderingRequired);
        }
        updatedData.current = updatedData_new;

    }, [removePermission_status, addPermission_status]);

    return [handlePermissionUpdate, updatedData];
}